import { CenteredLoadingIndicator } from "components/views/molecules/Molecules"
import React from "react"

export function FullScreenLoading(): JSX.Element {
  return <CenteredLoadingIndicator style={{ height: "100%" }} />
}
